import { Button } from 'antd';
import { AuctionBidsAPIUseCaseInterface } from 'application/usecases/AuctionBidsUseCase';
import IconCard from 'assets/icons/card-black.svg';
import IconCardBlue from 'assets/icons/card-blue.svg';
import IconCashCoin from 'assets/icons/cash-coin-black.svg';
import IconCashCoinBlue from 'assets/icons/cash-coin-blue.svg';
import IconCheck from 'assets/icons/check-circle-fill.svg';
import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { openErrorNoti } from 'presentation/components/Notification';
import {
    completeFetching,
    showAlert,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import { DetailAuctionBids } from '../models/AuctionBids';

const ITEM_LOAN = 'loan';
const ITEM_CASH = 'cash';
const LOAN_STATUS = 20;
const CASH_STATUS = 10;
const COLOR_BLACK = '#192F51';
const COLOR_BLUE = '#1F8DDD';

interface props {
    data?: DetailAuctionBids;
    auctionBidsUseCase: AuctionBidsAPIUseCaseInterface;
}

const CardItem = ({ data, auctionBidsUseCase }: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [chosenCategory, setChosenCategory] = useState<any>([]);
    const funcSetChosenCategory = (key: any) => {
        const checkKey = funcCheckChosenCategory(key);
        if (checkKey) {
            const newExpandKey = chosenCategory.filter((keyExpand: any) => keyExpand !== key);
            setChosenCategory(newExpandKey);
        } else {
            setChosenCategory([key]);
        }
    };

    const funcCheckChosenCategory = (key: any) => {
        if (!key || !chosenCategory) return false;
        return chosenCategory.some((element: any) => element === key);
    };

    const onSubmit = async () => {
        if (funcCheckChosenCategory(ITEM_LOAN)) {
            const params = {
                propertyDealProcedures: {
                    buyerMemberType: data?.memberType || ' ',
                    loanUseStatus: LOAN_STATUS,
                },
                auctionId: data?.auctionId || 0,
            };
            const response = await submitForm(params);
            dispatch(
                showAlert({
                    title: '購入申込の前に',
                    message: '落札価格での収支を\nシミュレーションしてみましょう',
                    okText: 'シミュレーション',
                    type: 'info',
                    onOk: () => {
                        const param = {
                            procedureId: response?.result.procedureId,
                            purchaseOfferId: response?.result.purchaseOfferId,
                            purchasePrice: data?.bidPrice,
                            loanUseStatus: LOAN_STATUS,
                        };
                        navigate(
                            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_058_01}/${response?.result.listedPropertyId
                            }?${commonHelpers.generateQueryString(param)}`,
                        );
                    },
                }),
            );
        } else {
            const params = {
                propertyDealProcedures: {
                    buyerMemberType: data?.memberType || ' ',
                    loanUseStatus: CASH_STATUS,
                },
                auctionId: data?.auctionId || 0,
            };
            const response = await submitForm(params);
            if (response?.result) {
                const param = {
                    listedPropertyId: response?.result.listedPropertyId,
                    procedureId: response?.result.procedureId,
                    purchaseOfferId: response?.result.purchaseOfferId,
                    purchasePrice: data?.bidPrice,
                    loanUseStatus: CASH_STATUS,
                };
                if (data?.memberType === '10') {
                    navigate(
                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_015_01
                        }?${commonHelpers.generateQueryString(param)}`,
                    );
                } else if (data?.memberType === '20') {
                    navigate(
                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_016_01
                        }?${commonHelpers.generateQueryString(param)}`,
                    );
                }
            }
        }
    };

    const submitForm = async (params: {
        propertyDealProcedures: {
            buyerMemberType: string;
            loanUseStatus: number;
        };
        auctionId: number;
    }) => {
        //api
        try {
            dispatch(startFetching());
            return await auctionBidsUseCase.updateDealProcedures(params);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div className="card-container">
            <div className="item-money">
                <div className="label-money text-label-money">落札額</div>
                <div className="text-money">
                    <div className="text-number-money">
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(data?.bidPrice)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                    </div>{' '}
                    <div className="text-label-money">万円</div>
                </div>
            </div>
            <div className="text-infor">支払い方法を選択してください。</div>
            <div className="item-category">
                <div className="category-container">
                    <div
                        className="category-child glow-on-hover"
                        onClick={() => funcSetChosenCategory(ITEM_CASH)}
                    >
                        <div className="category-content">
                            <div>
                                <ImageComponent
                                    src={
                                        funcCheckChosenCategory(ITEM_CASH)
                                            ? IconCashCoinBlue
                                            : IconCashCoin
                                    }
                                />
                            </div>
                            <div
                                style={{
                                    color: funcCheckChosenCategory(ITEM_CASH)
                                        ? COLOR_BLUE
                                        : COLOR_BLACK,
                                }}
                            >
                                現金
                            </div>
                        </div>
                        <div
                            className="icon-check-active"
                            style={{
                                display: funcCheckChosenCategory(ITEM_CASH) ? undefined : 'none',
                            }}
                        >
                            <img src={IconCheck} />
                        </div>
                    </div>
                    {data?.memberType === '10' && (
                        <div
                            className="category-child glow-on-hover"
                            onClick={() => funcSetChosenCategory(ITEM_LOAN)}
                        >
                            <div className="category-content">
                                <div>
                                    <img
                                        src={
                                            funcCheckChosenCategory(ITEM_LOAN)
                                                ? IconCardBlue
                                                : IconCard
                                        }
                                    />
                                </div>
                                <div
                                    style={{
                                        color: funcCheckChosenCategory(ITEM_LOAN)
                                            ? COLOR_BLUE
                                            : COLOR_BLACK,
                                    }}
                                >
                                    ローン
                                </div>
                            </div>
                            <div
                                className="icon-check-active"
                                style={{
                                    display: funcCheckChosenCategory(ITEM_LOAN)
                                        ? undefined
                                        : 'none',
                                }}
                            >
                                <img src={IconCheck} />
                            </div>
                        </div>
                    )}
                </div>
                <div className="text-note">ご自身の提携銀行を使用される方は現金を選択ください</div>
                <div className="text-suggest">
                    詳しくは
                    <a href={LINK_URL.MANAGEMENT_RENT_DETAIL} target="_blank" rel="noopener noreferrer" className="link-component">
                        こちら
                    </a>
                </div>
            </div>
            <div className="btn-container">
                <Button
                    onClick={onSubmit}
                    type="primary"
                    form="form-select"
                    style={{ width: '100%', height: '56px' }}
                    disabled={chosenCategory.length == 0}
                >
                    次へ
                </Button>
            </div>
        </div>
    );
};

export default CardItem;
